import React, {useState, useEffect} from 'react';
import {HashRouter as Router, Routes, Route, useLocation, useNavigationType} from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ServicePages from './components/ServicePages';
import ContactPage from './components/ContactPage';
import ReferencesPage from './components/ReferencesPage';
import AboutPage from './components/AboutPage';
import ImpressumPage from './components/ImpressumPage';
import DatenschutzPage from './components/DatenschutzPage';
import AGBPage from './components/AGBPage';
import MobileCTA from './components/MobileCTA';
import Home from './components/Home';

const LocationHandler = () => {
  const {pathname} = useLocation();
  const action = useNavigationType();

  useEffect(() => {
    if (action !== 'POP') {
      window.scrollTo(0, 0);
    }
    
    document.body.style.overflow = 'unset';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
    document.documentElement.style.overflow = 'unset';
  }, [pathname, action]);

  return null;
};

function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <LocationHandler />
        <Header />
        
        <div className="flex-grow w-full">
          <Routes>
            <Route path="/leistungen/*" element={<ServicePages />} />
            <Route path="/ueber-uns" element={<AboutPage />} />
            <Route path="/referenzen" element={<ReferencesPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/agb" element={<AGBPage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>

        {isMobile && <MobileCTA />}
        <Footer />
      </div>
    </Router>
  );
}

export default App;